import { render } from "./StudyDownloadDialog.vue?vue&type=template&id=40a96eb1&scoped=true"
import script from "./StudyDownloadDialog.vue?vue&type=script&lang=js"
export * from "./StudyDownloadDialog.vue?vue&type=script&lang=js"

import "./StudyDownloadDialog.vue?vue&type=style&index=0&id=40a96eb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a96eb1"]])

export default __exports__